import { ImageTagDetail } from '@spencer/apis/ecrPublicClient';
import { formatDistance } from 'date-fns';

const DatePushedCell = (item: ImageTagDetail) =>
  formatDistance(new Date(item.createdAt), new Date(), { addSuffix: true });

export default DatePushedCell;
